export const YearTypeConst = {Melady:1, Maly:2}